import { gql } from 'graphql-tag'
import { fragmentModuleMedia } from '#layers/core/data-layer/modules/fragments'

export default gql`
  ${fragmentModuleMedia}
  fragment PagePartnersDetailFragment on PagePartnersDetail {
    sys {
      id
    }
    slug
    partnerName
    partnerDescription
    partnerLogo {
      ...ModuleMediaFragment
    }
    accreditationStatus
  }
`
